module.exports = __webpack_public_path__ + "media/images/slider-big-arrow-right-blue-be2012f2307ec0de9570f64cb2578d59.png";